<label [attr.for]="inputId"
       #label>

    <input #input
           class="visually-hidden"
           [id]="inputId"
           type="radio"
           [required]="required"
           [checked]="checked"
           [attr.value]="value"
           [disabled]="disabled"
           [attr.name]="name"
           [attr.aria-label]="ariaLabel || null"
           [attr.aria-labelledby]="ariaLabelledby"
           (change)="onInputChange($event)">

    <i [class.icon-radio-checked]="checked"
       [class.icon-radio-unchecked]="!checked"></i>

    <span class="radio__body">
        <ng-content />
    </span>
</label>